export default __webpack_public_path__ + "static/media/logo.d85caf52.svg";